<template>
  <div>
    <nav v-if="prevRouteName">
      <router-link :to="{ name: prevRouteName }"><el-button type="primary" icon="el-icon-arrow-left">Back to {{routeLabel(prevRouteName)}}</el-button></router-link>
    </nav>
    <el-container>
      <main id="profile">
        <h2>Update Your Details</h2>
        <div v-loading="updateCustomerStatus == 'pending' || getCustomerStatus == 'pending'">
          <el-form
            v-if="customer && customer.id"
            novalidate="true"
            label-width="10em"
            :label-position="formLabelPosition"
            :size="formSize"
          >
            <el-form-item label="Title" :error="errors.title">
              <el-select placeholder="Title" v-model="customer.title" filterable>
                <el-option
                  v-for="title in titles"
                  :key="title"
                  :label="title"
                  :value="title">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="First Name" :error="errors.first_name">
              <el-input placeholder="First Name" v-model="customer.first_name"></el-input>
            </el-form-item>
            <el-form-item label="Last Name" :error="errors.last_name">
              <el-input placeholder="Last Name" v-model="customer.last_name"></el-input>
            </el-form-item>
            <el-form-item label="Phone Number" :error="errors.phone_number">
              <el-input placeholder="Phone Number" v-model="customer.phone_number"></el-input>
            </el-form-item>
            <el-form-item label="Postcode" :error="errors.zip_code"  v-if="accountFields.includes('zip_code')">
              <el-input placeholder="Postcode" v-model="customer.zip_code" type="text" v-mask="postcodeMask"></el-input>
              <div class="postcode-lookup" v-if="hasGetAddress">
                <el-button type="primary" @click="postcodeLookup" :loading="getAddressStatus == 'pending'">Find Address</el-button>
                <el-select placeholder="Select an Address" v-if="addresses.length" v-model="selectedAddress">
                  <el-option
                    v-for="address, index in addresses"
                    :key="index"
                    :label="formatAddress(address)"
                    :value="index"/>
                 </el-select>
              </div>
            </el-form-item>
            <el-form-item label="Property Name/Number" :error="errors.street_number" v-if="accountFields.includes('street_number')">
              <el-input placeholder="Property Name/Number" v-model="customer.street_number"></el-input>
            </el-form-item>
            <el-form-item label="Street" :error="errors.street" v-if="accountFields.includes('street')">
              <el-input placeholder="Street" v-model="customer.street"></el-input>
            </el-form-item>
            <el-form-item label="City" :error="errors.city" v-if="accountFields.includes('city')">
              <el-input placeholder="City" v-model="customer.city"></el-input>
            </el-form-item>
            <el-form-item label="Country" :error="errors.country" v-if="accountFields.includes('country')">
              <el-select placeholder="Country" v-model="customer.country" filterable>
                <el-option
                  v-for="country in countries"
                  :key="country"
                  :label="country"
                  :value="country">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="user && user.provider == 'remote' && !user.is_guest">
              <el-checkbox label="I would like to change my password" v-model="changePassword" />
            </el-form-item>
            <el-form-item v-if="user && user.provider == 'remote' && !user.is_guest && changePassword" label="New Password" :error="errors.password">
              <el-input placeholder="Change your password" v-model="customer.password" show-password></el-input>
            </el-form-item>
            <el-form-item v-if="user && user.provider == 'remote' && !user.is_guest && changePassword" label="Confirm Password" :error="errors.password_confirmation">
              <el-input placeholder="Confirm your new password" v-model="customer.password_confirmation" show-password></el-input>
            </el-form-item>
            <el-form-item v-if="user && !user.is_guest">
              <el-checkbox :label="allowEmailsLabel || 'I consent to being contacted by email'" v-model="customer.allow_e_mails" true-label="Yes" false-label="No" />
            </el-form-item>
            <el-form-item>
              <el-button type="success" class="proceed" v-on:click="submit">{{nextLabel}} <i class="el-icon-arrow-right"></i></el-button>
            </el-form-item>
          </el-form>
        </div>
      </main>
      <aside>
        <cart :activeMobileSections="[]" />
        <el-button type="success" class="proceed" v-on:click="submit">{{nextLabel}} <i class="el-icon-arrow-right"></i></el-button>
      </aside>
    </el-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import api from '../api/api'
  import formMixin from '../mixins/formMixin'
  import sessionMixin from '../mixins/sessionMixin'
  import profileMixin from '../mixins/profileMixin'
  import cart from '../components/cart.vue'

  export default {
    mixins: [formMixin, sessionMixin, profileMixin],
    methods: {
      submit() {
        this.$store.dispatch('customer/updateCustomer', this.customer)
      }
    },
    components: {
      cart
    },
    computed: {
      ...mapState({
        allowEmailsLabel: state => state.settings.tenant.allow_emails_label,
        hasGetAddress: state => state.settings.tenant.has_get_address,
        updateCustomerStatus: state => state.customer.status.updateCustomer,
        getCustomerStatus: state => state.customer.status.getCustomer,
        user: state => state.session.user,
        storedCustomer: state => state.customer.customer,
        accountFields: state => state.settings.tenant.account_fields
      }),
      nextLabel() {
        if (this.$route.name == 'profile')
          return 'Save and Continue'
        else
          return 'Next Step'
      }
    },
    created() {
      if (!this.user) {
        this.$router.push({name: 'account', params: { redirect: this.getRedirect()}})
        return
      }
      this.$store.dispatch('customer/getCustomer')
    },
    watch: {
      storedCustomer() {
        this.customer = Object.assign({}, this.storedCustomer)
        if (this.user && this.user.provider == 'facebook')
          this.$message({message: "You're logged in with Facebook"})
      },
      updateCustomerStatus() {
        if (this.updateCustomerStatus == 'success')
          this.redirect()
      },
      changePassword() {
	if (!this.changePassword) {
		this.customer.password = ''
		this.customer.password_confirmation = ''
	}
      }
    },
    data() {
      return {
        changePassword: false
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../styles/settings.scss";
  @import "../styles/mixins.scss";

  .el-alert {
    margin-bottom: 1em;
  }
  .postcode-lookup {
    margin-top: 0.5em;
  }

  aside .proceed {
    margin-top: 1em;
    float: none;
    width: 100%;
    height: 4em;
    @extend button.big;
  }

  @media (min-width: $mobile-max + 1) {
    .proceed.mobile-only {
      display: none;
    }
  }

  @media (max-width: $mobile-max) {
    aside .proceed {
      display: none;
    }

    .proceed {
      margin-top: 1em;
      float: none;
      width: 100%;
      height: 4em;
      @include button-big;
    }
  }
</style>
